module.exports = __webpack_public_path__ + "static/img/12areaB_07.609a24f.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/12areaB_07.png
// module id = 1108
// module chunks = 1